import type { FC, ReactNode } from 'react'

import { useState } from 'react'
import { Eye, EyeOff } from 'lucide-react'
import { useI18n } from '@/i18n/context'
import { TextInput } from '@/components/primitives/field'

interface PasswordInputProps {
    id: string
    value: string
    onChange: (value: string) => void
    invalid?: boolean
    autoComplete: 'current-password' | 'new-password'
}

export const PasswordInput: FC<PasswordInputProps> = ({ id, value, onChange, invalid, autoComplete }): ReactNode => {
    const { m } = useI18n()
    const [visible, setVisible] = useState(false)

    return (
        <div className='relative'>
            <TextInput
                id={id}
                type={visible ? 'text' : 'password'}
                value={value}
                invalid={invalid}
                autoComplete={autoComplete}
                onChange={event => onChange(event.target.value)}
                className='pe-12'
            />

            <button
                type='button'
                onClick={() => setVisible(current => !current)}
                aria-label={visible ? m.auth.hidePassword : m.auth.showPassword}
                aria-pressed={visible}
                className='absolute end-1.5 top-1/2 flex size-9 -translate-y-1/2 items-center justify-center rounded-lg text-muted-foreground transition hover:bg-white/5 hover:text-gold focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold'
            >
                {visible ? <EyeOff className='size-5' aria-hidden='true' /> : <Eye className='size-5' aria-hidden='true' />}
            </button>
        </div>
    )
}
